<template>
  <div v-if="displayedOrganizations.length">
    <div v-if="!selectedOrganization" class="organizations">
      <h3 class="organizations-title">Выберите организацию</h3>
      <button
        v-for="org in displayedOrganizations"
        :key="org.id"
        class="organizations-item"
        type="button"
        @click="selectOrganization(org)"
      >
        <p class="organizations-name">
          {{ org.full_name || org.short_name }}
        </p>
        <p v-if="org.address" class="organizations-address">
          {{ org.address }}
        </p>
        <BaseButton
          class="mt-s"
          size="xs"
          shape="square"
          @click.stop="selectOrganization(org)"
          >Выбрать</BaseButton
        >
      </button>
      <paginate
        v-if="pageCount > 1"
        v-model="page"
        :page-count="pageCount"
        container-class="pager"
        page-class="pager__page"
        next-class="pager__arrow pager__arrow--next"
        prev-class="pager__arrow pager__arrow--prev"
        prev-text=""
        next-text=""
        class="paginate"
      >
      </paginate>
    </div>
    <div v-else class="organizations">
      <h3 class="organizations-title">Выбранная организация</h3>
      <div class="organizations-item selected">
        <p class="organizations-name">
          {{
            selectedOrganization.full_name || selectedOrganization.short_name
          }}
        </p>
        <p v-if="selectedOrganization.address" class="organizations-address">
          {{ selectedOrganization.address }}
        </p>
        <BaseButton
          class="mt-s"
          size="xs"
          shape="square"
          @click="selectOrganization(null)"
          >отменить выбор</BaseButton
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrganizationSelect",
  data() {
    return {
      page: 1,
      pageLimit: 5,
    };
  },
  computed: {
    organizations() {
      return this.$store.state.requestPreparing.organizations;
    },
    selectedOrganization() {
      return this.$store.state.requestPreparing.selectedOrganization;
    },
    venuePending() {
      return this.$store.state.requestPreparing.loadPending;
    },
    displayedOrganizations() {
      const start = (this.page - 1) * this.pageLimit;
      const end = start + this.pageLimit;
      return this.organizations.slice(start, end);
    },
    pageCount() {
      return Math.ceil(this.organizations.length / this.pageLimit);
    },
    organizationsPlatforms() {
      return this.$store.state.requestPreparing.organizationsPlatforms;
    },
  },
  methods: {
    async selectOrganization(org) {
      if (this.venuePending) return;
      this.$store.commit("requestPreparing/SET_SELECTED_ORGANIZATION", org);
      if (!org) {
        this.$store.commit("requestPreparing/SET_SELECTED_PLATFORM", null);
        return;
      }
      if (!!org && !this.organizationsPlatforms[org.id]) {
        await this.$store.dispatch("requestPreparing/getPlatforms", {
          orgId: org.id,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.organizations {
  margin-top: @margin-xl;

  &-item {
    padding: 0;
    width: 100%;
    display: block;
    border: none;
    font: inherit;
    color: inherit;
    background-color: transparent;
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    padding: 20px 30px;
    border-radius: @border-radius-xs;
    margin-bottom: @margin-s;
    box-shadow: 0 1px 2px rgba(45, 87, 96, 0.2);
    transition: transform 0.3s;

    &:hover {
      transform: scale(1.02);
    }

    &.selected {
      border: 1px dashed @primary-color;
      cursor: default;
      &:hover {
        transform: scale(1);
      }
    }
  }
  &-title {
    font-size: @font-size-h4;
    line-height: @line-height-h4;
    text-align: center;
    font-weight: bold;
    margin-bottom: @margin-l;
  }
  &-name {
    font-weight: bold;
  }
  &-address {
    font-size: @font-size-s;
    line-height: @line-height-s;
  }
}

.paginate {
  display: flex;
  justify-content: center;
  margin-top: @margin-l;
}

@media (max-width: @screen-xs) {
  .organizations {
    &-title {
      font-size: @font-size-l;
      line-height: @line-height-l;
    }
  }
}
</style>
